var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('p',{staticClass:"loginInfo"},[_c('b-button',{on:{"click":_vm.triggerLogin}},[_vm._v("Login with Discord")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }